"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Pagination = function (_a) {
    var paginationData = _a.paginationData, searchParams = _a.searchParams, setSearchParams = _a.setSearchParams;
    var page = paginationData;
    var paginationElement = [];
    if (page) {
        var firstPage = page.currentPage - 2;
        var lastPage = page.currentPage + 4;
        var _loop_1 = function (i) {
            if (i > 0 && i <= page.total_pages) {
                if (i === firstPage && i > 1) {
                    paginationElement.push(react_1.default.createElement("li", { key: i, className: "page-prev" },
                        react_1.default.createElement("a", { onClick: function () {
                                window.scrollTo({
                                    top: 0,
                                    behavior: "smooth",
                                });
                                setSearchParams(__assign(__assign({}, searchParams), { pg: page.currentPage - 1 }));
                            } },
                            react_1.default.createElement("span", { className: "glyphicon glyphicon-chevron-left" }))));
                }
                paginationElement.push(react_1.default.createElement("li", { key: i, className: i === page.currentPage ? "act" : "" },
                    react_1.default.createElement("a", { onClick: function () {
                            window.scrollTo({
                                top: 0,
                                behavior: "smooth",
                            });
                            setSearchParams(__assign(__assign({}, searchParams), { pg: i }));
                        } }, i)));
                if (i === lastPage && i < page.total_pages) {
                    paginationElement.push(react_1.default.createElement("li", { key: i, className: "page-next" },
                        react_1.default.createElement("a", { onClick: function () {
                                window.scrollTo({
                                    top: 0,
                                    behavior: "smooth",
                                });
                                setSearchParams(__assign(__assign({}, searchParams), { pg: page.currentPage + 1 }));
                            } },
                            react_1.default.createElement("span", { className: "glyphicon glyphicon-chevron-right" }))));
                }
            }
        };
        for (var i = firstPage; i <= lastPage; i++) {
            _loop_1(i);
        }
    }
    return react_1.default.createElement(react_1.Fragment, null, paginationElement);
};
exports.default = Pagination;
